package modysy.gamestate

/** Contains values for all possible States the Game can have
  *
  */
object GameState extends Enumeration {
  type GameState = Value
  val ingamePlaying, ingamePaused, mainMenu, levelMenu, endscreenWin,
  endscreenLose = Value
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/gamestate/GameState.scala